// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { AccountTilesModel, getAccountTilesData } from "@flip/App/Services/AccountService";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<
    HasOnSuccess<AccountTilesModel> & HasOnError<string>,
    AccountTilesModel & { error?: string }
>;

export const DispatchBeginLoadCreateAccountInfo: HandlerType = props => {};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getAccountTilesData();
    } catch (error) {
        props.apiResult.error =
            error.errorMessage || "Please try again and contact support if you continue to have issues.";
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (!props.apiResult.error) {
        const { error, ...result } = props.apiResult;
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(result);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (props.apiResult.error) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.error);
    }
};

export const chain = [
    DispatchBeginLoadCreateAccountInfo,
    RequestDataFromApi,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
];

const loadAccountTiles = createHandlerChainRunner(chain, "LoadAccountTiles");

export default loadAccountTiles;
